import React from "react";
import { nonHiddenWords, allowedPunctionation } from "../utils/wordHelpers";

interface GuessedWordsTableProps {
  wordsMap: Map<string, number>;
}

const GuessedWordsTable = ({ wordsMap }: GuessedWordsTableProps) => {
  const guessedWords = Array.from(wordsMap.keys()).filter(
    (value) => !nonHiddenWords.includes(value) && !allowedPunctionation.includes(value)
  );
  return (
    <div className="max-h-[80vh] overflow-auto">
      <table className="min-w-full border border-gray-300">
        <thead className="bg-gray-100">
          <tr>
            <th className="border border-gray-300 px-4 py-2">Guess #</th>
            <th className="border border-gray-300 px-4 py-2">Word</th>
            <th className="border border-gray-300 px-4 py-2">Hits</th>
          </tr>
        </thead>

        <tbody>
          {guessedWords.reverse().map((word, index) => (
            <tr key={index} className="odd:bg-white even:bg-gray-50">
              <td className="border border-gray-300 px-4 py-2">{guessedWords.length - index}</td>
              <td className="border border-gray-300 px-4 py-2">{word}</td>
              <td className="border border-gray-300 px-4 py-2">{wordsMap.get(word)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GuessedWordsTable;
